/*
 * Clicar numa menção @fulano abre o cartão de usuário —
 * o mesmo cartão do avatar do post. Ctrl/Cmd+clique continua abrindo o
 * perfil numa aba nova.
 *
 * O link da menção só traz o endereço do perfil (/u/slug): o usuário vem do
 * store quando já foi carregado, ou da API pelo slug.
 */
import app from 'flarum/forum/app';
import { openUserCard } from '../../topic/components/UserCardPopover';
import { gaps } from '../settings';
const MENTION = '.Post-body a.UserMention, .CanelaEmbeddedPost-body a.UserMention';
export function slugFrom(link) {
  try {
    const path = new URL(link.href, window.location.href).pathname;
    const match = path.match(/\/u\/([^/]+)\/?$/);
    return match ? decodeURIComponent(match[1]) : null;
  } catch {
    return null;
  }
}
export function findUser(slug) {
  const lower = slug.toLowerCase();
  const cached = app.store.all('users').find(user => String(user.slug()).toLowerCase() === lower || String(user.username()).toLowerCase() === lower);
  if (cached) return Promise.resolve(cached);
  return app.store.find('users', slug, {
    bySlug: true
  }, {
    errorHandler: () => {}
  }).then(user => user || null).catch(() => null);
}
function onClick(event) {
  if (!gaps.mentionCards()) return;
  if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
  const link = event.target?.closest?.(MENTION);
  if (!link) return;
  const slug = slugFrom(link);
  if (!slug) return;
  event.preventDefault();
  event.stopPropagation();
  findUser(slug).then(user => {
    // Sem o usuário (apagado, sem permissão), o link volta a ser só um link.
    if (user) openUserCard(user, link);else window.location.href = link.href;
  });
}
export default function installMentionCards() {
  // Na captura: o Link do Mithril em volta do post navegaria antes.
  document.addEventListener('click', onClick, true);
}
flarum.reg.add('ramon-canela', 'forum/gaps/cooked/mentions', installMentionCards);